<script>
  import Store from '../../../utils/catch-state'
  import {FORM_POSITION_SPAN} from '../../../const/static'

  export default {
    name: 'form-layout',
    props: {
      span: {
        type: [String]
      },
      styleType: {
        type: [String],
        default: 'medium'
      }
    },
    data () {
      return {
        apiPosition: 'right'
      }
    },
    inject: ['syForm'],
    computed: {
      defaultSpan () {
        const defaultSpan = FORM_POSITION_SPAN[this.computedPosition]
        return this.span || defaultSpan
      },
      defaultSlot () {
        // 过滤掉隐藏字段
        return (this.$scopedSlots.default || this.$slots.default || [])
      }
    },
    async created () {
      await this.getLabelPosition()
    },
    methods: {
      computedPosition () {
        return this.syForm?.labelPosition || this.apiPosition
      },
      async getLabelPosition () {
        this.apiPosition = await Store.getInterfaceData('getType').getter()
      },
      getSpan (item) {
        let spanArr = [
          item.componentOptions?.propsData.span,
          item.componentOptions?.propsData.node.props.span,
          this.span,
          this.defaultSpan,
          2
        ]
        return spanArr.find(v => {
          return v === 0 || v
        })
      }
    },
    render (h) {
      return (
        <div class="form-layout">
          {
            this.defaultSlot.map(
              item => (
                <div
                  key={item.key}
                  class={['sy-col', 'sy-col-' + this.getSpan(item)]}
                >
                  {item}
                </div>
              )
            )
          }
        </div>
      )
    }
  }
</script>

<style lang='scss' scoped>
  .form-layout {
    margin: 0 0 -24px;
    // font-size: 0;
    .sy-col {
      // background: rgb(228, 228, 188);
      display: inline-block;
      .sy-form-item{
        width: 310px;
      }
      .sy-form-item--mini{

      }
      .sy-form-item--small{
        width: 280px;
      }
      .sy-form-item--large{
        width: 400px;
      }
    }
    .sy-col-0 {
      width: 100%;
      .sy-form-item{
        width: 100%;
      }
    }
    .sy-col-1 {
      width: 100%;
    }
    .sy-col-2 {
      width: 50%;
    }
    .sy-col-3 {
      width: 33.33%;
    }
  }
</style>
